// @ts-nocheck

import { type Selector } from '../../../../types/selectors';
import { createResultEqualSelector } from '../../../../utils/reselect';
import { selectIsBoomPlayable } from '../../selectors/runtime.selector';

type BoomEnrollmentPropsType = {
  isPlayable: boolean;
};

const selectBoomEnrollmentProps: Selector<BoomEnrollmentPropsType> = createResultEqualSelector(
  [selectIsBoomPlayable],
  (isPlayable) => ({
    isPlayable,
  }),
);

export default selectBoomEnrollmentProps;
